import { Action } from '../../../shared/xs/actions';

export class GetCo2CalculationsListAction implements Action {
  static readonly type = '[Co2Calculator] Get CO2 calculations list';
}
